

export function UploadProgressOverlay({ steps }) {
  return (
    <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.75)",
      zIndex: 1000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <div style={{
        background: "#fff",
        borderRadius: 16,
        padding: "32px 40px",
        minWidth: 280,
        display: "flex",
        flexDirection: "column",
        gap: 20,
      }}>
        <p style={{
          margin: 0,
          fontSize: 15,
          fontWeight: 800,
          fontFamily: "'Nunito', sans-serif",
          color: "#1a1a1a",
          textAlign: "center",
          letterSpacing: "0.01em",
        }}>
          Great Things Takes Time…
        </p>

        {steps.map((step, i) => (
          <div key={i} style={{
            display: "flex",
            alignItems: "center",
            gap: 14,
          }}>
            {/* Icon */}
            <div style={{ width: 24, height: 24, flexShrink: 0 }}>
              {step.status === "done" && (
                <svg viewBox="0 0 24 24" fill="none" width="24" height="24">
                  <circle cx="12" cy="12" r="10" fill="#34A853" />
                  <path d="M7 12.5l3.5 3.5 6.5-7"
                    stroke="#fff" strokeWidth="2.2"
                    strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
              {step.status === "loading" && <Spinner />}
              {step.status === "pending" && (
                <div style={{
                  width: 24, height: 24, borderRadius: "50%",
                  border: "2px solid #e0e0e0",
                  boxSizing: "border-box",
                }} />
              )}
            </div>

            {/* Label */}
            <span style={{
              fontSize: 14,
              fontFamily: "'Nunito', sans-serif",
              fontWeight: step.status === "loading" ? 700 : 400,
              color: step.status === "pending" ? "#bbb"
                : step.status === "loading" ? "#1a1a1a"
                  : "#34A853",
              transition: "color 0.3s",
            }}>
              {step.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

function Spinner() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        .spin-ring { transform-origin: 12px 12px; animation: spin 0.8s linear infinite; }
      `}</style>
      <circle cx="12" cy="12" r="10"
        fill="none" stroke="#e0e0e0" strokeWidth="2.5" />
      <path className="spin-ring"
        d="M12 2 a10 10 0 0 1 10 10"
        fill="none" stroke="#4285F4" strokeWidth="2.5"
        strokeLinecap="round" />
    </svg>
  );
}